import { apiRequest } from "@/shared/lib/apiClient";

export type ForgotPasswordResponse = {
  sent: boolean;
  mail_configured: boolean;
  proceed_to_reset: boolean;
  message: string;
  debug_code?: string;
};

export async function requestPasswordReset(email: string): Promise<ForgotPasswordResponse> {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), 15000);

  try {
    return await apiRequest<ForgotPasswordResponse>("/auth/forgot-password", {
      method: "POST",
      body: { email: email.trim() },
      signal: controller.signal,
    });
  } finally {
    window.clearTimeout(timeoutId);
  }
}

export async function resetPasswordWithCode(payload: {
  email: string;
  code: string;
  password: string;
  password_confirmation: string;
}): Promise<{ message: string }> {
  return apiRequest<{ message: string }>("/auth/reset-password", {
    method: "POST",
    body: payload,
  });
}
